// Общие помощники для узлов схемы: атрибут id, подключение отображения из реестра nodeViews.
import { ReactNodeViewRenderer } from '@tiptap/react';
import { registry } from '../registry';

/** Атрибут id блока (data-id в HTML). Значение ставит плагин ids.ts. */
export function idAttr() {
  return {
    id: {
      default: null as string | null,
      parseHTML: (el: HTMLElement) => el.getAttribute('data-id'),
      renderHTML: (a: Record<string, any>) => (a.id ? { 'data-id': a.id } : {}),
    },
  };
}

/** JSON-атрибут (массив/объект) с сериализацией в data-* (для копирования между вкладками редактора). */
export function jsonAttr<T>(name: string, def: T) {
  return {
    default: def,
    parseHTML: (el: HTMLElement) => {
      const v = el.getAttribute('data-' + name);
      if (!v) return def;
      try { return JSON.parse(v); } catch { return def; }
    },
    renderHTML: (a: Record<string, any>) => (a[name] !== undefined && a[name] !== null ? { ['data-' + name]: JSON.stringify(a[name]) } : {}),
  };
}

/** addNodeView(): отображение из реестра (если функция его зарегистрировала), иначе - renderHTML схемы. */
export function registryNodeView(name: string) {
  return function addNodeView() {
    const spec = registry.nodeViews.get(name);
    if (!spec) return null as any;
    return ReactNodeViewRenderer(spec.component as any, spec.options as any);
  };
}

/** Простой уникальный id: буква + 9 символов [a-z0-9] (годится для закладки Word и метки writer). */
export function newId(): string {
  const a = 'abcdefghijklmnopqrstuvwxyz0123456789';
  let s = 'n';
  const rnd = crypto.getRandomValues(new Uint8Array(9));
  for (const b of rnd) s += a[b % 36];
  return s;
}
